<template>
  <div
    v-for="item in transformedData"
    :key="item.groupId"
    class="tw:mb-6 tw:last:mb-2"
    data-testid="product-container-item"
  >
    <h3 class="tw:font-bold tw:text-black tw:mb-4">
      {{ item.name }}
    </h3>
    <div class="tw:flex tw:flex-col tw:mb-3 tw:last:mb-0" v-for="(product, index) in item.items" :key="index">
      <ProductItem :product="product" :accommodationName="getAccommodationName(item.groupId)" />
    </div>
  </div>
</template>
<script setup>
import ProductItem from '@/components/billing/premiumProducts/ProductItem.vue'
import { computed } from 'vue'

const props = defineProps({
  accommodationsData: Array,
  data: Object,
})

const getAccommodationName = accommodationId => {
  return props.accommodationsData.find(item => Number(item.accommodationId) === Number(accommodationId))?.name
}

const transformedData = computed(() =>
  Object.entries(props.data)
    .map(([groupId, items]) => ({
      groupId,
      name: getAccommodationName(groupId) ?? String(groupId),
      items,
    }))
    .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
)
</script>
